import { render, staticRenderFns } from "./driverslicense.vue?vue&type=template&id=67c35b04&"
import script from "./driverslicense.vue?vue&type=script&lang=js&"
export * from "./driverslicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports